<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalModalStore } from '../../store/globalModal.store'

const props = withDefaults(defineProps<{
  title?: string
  shortcut?: string
  width?: string
  fullscreen?: boolean
}>(), {
  title: 'Modal',
  shortcut: 'F2',
  width: '50%',
  fullscreen: false
})

const store = useGlobalModalStore()
const { isOpen } = storeToRefs(store)

function handleKeyDown(e: KeyboardEvent) {
  if (e.key === props.shortcut) {
    e.preventDefault()
    store.toggle()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown)
})
</script>

<template>
  <el-dialog
    v-model="isOpen"
    :title="title"
    :width="width"
    :fullscreen="fullscreen"
    :close-on-click-modal="true"
    :append-to-body="true"
    :class="{ 'global-modal--fullscreen': fullscreen }"
    destroy-on-close
  >
    <slot />
  </el-dialog>
</template>

<style>
/* Non-scoped : .global-modal--fullscreen est posée sur la racine <el-dialog> elle-même,
   qui porte déjà l'attribut de scope Vue — un sélecteur scoped avec :deep() chercherait
   à tort un ANCÊTRE portant cet attribut et ne matcherait jamais rien. */

/* Hauteur explicite (plutôt que flex:1 sur el-dialog__body) : évite de dépendre du
   comportement flex interne d'el-dialog, qui ne garantit pas toujours la contrainte
   de hauteur nécessaire au scroll interne du tableau. */
.global-modal--fullscreen .el-dialog__body {
  height: calc(100vh - 54px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 16px 32px 24px;
}

.global-modal--fullscreen .el-dialog__body > * {
  flex: 1;
  min-height: 0;
}
</style>
